<template>
    <div class="home__component">
        <div class="banner animate__animated animate__fadeIn">
            <el-carousel height="900px">
                <el-carousel-item  v-for="(item,index) in bannerImgs" :key="index">
                  <img :src="item.url" class="banner__img">
                </el-carousel-item>
            </el-carousel>
            <div class="submit__base wow animate__fadeIn">
                <div>
                    <el-input
                            placeholder="所在城市"
                            v-model="city"
                            clearable>
                    </el-input>
                </div>
                <div>
                    <el-input
                            placeholder="别墅面积"
                            v-model="area"
                            clearable>
                    </el-input>
                </div>
                <div>
                    <el-input
                            placeholder="您的称呼"
                            v-model="name"
                            clearable>
                    </el-input>
                </div>
                <div>
                    <el-input
                            placeholder="联系电话"
                            v-model="mobile"
                            maxlength="11"
                            clearable>
                    </el-input>
                </div>
                <div><el-button type="primary" class="submit__button" @click="submitFun" :loading="isSubmit">提交</el-button></div>
            </div>
        </div>
        <div>
            <!--1.合作项目设计师-->
            <div class="dep__group">
                <div class="dep__type">
                    <div class="dep__lable  wow animate__fadeInUp">
                        <div>隐上发展史</div>
                        <div class="eg">History of Development</div>
                        <img :src="icon_hyz">
                    </div>
                    <div class="bg"><img :src="icon_pxs" style="height: 416px;object-fit: cover;"></div>
                </div>
                <!--时期列表-->
                <div class="dep__time--line wrapper__w over wow animate__fadeInUp relative"

                     :style="{background: 'url('+icon_dl+')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
                    <div v-for="(item, index) in timeline" class="fl line__item" @click="lookTimeLine(index)">
                        <div class="bot">
                            <div class="name">{{item.name}}</div>
                            <div class="time">{{item.time}}</div>
                            <span class="line__tag"></span>
                        </div>
                    </div>
                    <!-- 点击某个时期-->
                    <div v-if="isTimeObj" class="timeObj__box wrapper__w animate__animated animate__fadeIn" data-wow-delay="1s" data-wow-duration="1.8s" @click="closeTime()">
                        <div   class="dep__show " :style="{background: 'url('+icon_fjs+')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
                        <div>
                            <div class="dep__time">{{timeObj.time_name}}</div>
                            <div class="over" >
<!--                                <div class="fl dep__lay swiper-container">-->
<!--                                    <div class="swiper-wrapper">-->
<!--                                        <div class="swiper-slide" @click.stop="" v-for="url in timeObj.imgList" style="height: 200px">-->
<!--                                            <img  :src="url.url" >-->
<!--                                            <div class="name__text">{{url.name}}</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="fl dep__lay">
                                    <div :style="{width: timeObj.imgRight.length * 200 +'px!important'}">
                                        <vue-seamless-scroll :data="timeObj.imgRight" :class-option="classOption2" >
                                            <div  @click.stop="" v-for="(url, index) in timeObj.imgRight" class="timeObj__imgs">
                                                <img  :src="url.url" >
                                                <div class="name__text">{{url.name}}</div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>
                                    <div :style="{width: timeObj.imgLeft.length * 200 +'px!important'}">
                                        <vue-seamless-scroll :data="timeObj.imgLeft" :class-option="classOption1" >
                                            <div  @click.stop="" v-for="(url, index) in timeObj.imgLeft" class="timeObj__imgs">
                                                <img  :src="url.url" >
                                                <div class="name__text">{{url.name}}</div>
                                            </div>
                                        </vue-seamless-scroll>
                                    </div>

                                </div>
                                <div class="dep__des fr">
                                    <img :src="icon_hyz" >
                                    <vue-seamless-scroll :data="timeObj.textList" :class-option="classOption" >
                                        <div  v-for="text in timeObj.textList">{{text.text}}</div>
                                    </vue-seamless-scroll>
                                </div>

                            </div>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
            <!--2.合作项目设计师-->
            <div class="dep__group ">
                <div class="dep__type wrapper__wpd">
                    <div class="dep__lable wow animate__fadeInUp" style="margin-top: -98px">
                        <div>合作项目设计师</div>
                        <div class="eg">Project Designers</div>
                        <img :src="icon_hyz">
                    </div>
                    <div class="bg" style="height: 550px;"></div>
                </div>
                <div class="wrapper__wpd dep__bg relative" style="height: 1170px">
                    <div class="pro__user over " style="position: relative;top: -255px;z-index: 2">
                        <div class=" fl wow animate__fadeInUp" @click="preeItem('/strategic/designer', {id: item.id}, index)" :class="index == 2 ? 'pro__down' : (designerBig.indexOf(index) != -1  ? 'pro__left' : 'pro__top')" v-for="(item, index) in designerList" :key="index" v-if="index < 9">
                            <div class="head  relative over"  v-if="index != 2" :class="designerBig.indexOf(index) != -1  ? 'fl' : ''" >
                                <img :src="item.image" class="designer__picture p_i_e_box">
                                <img :src="item.project_image" class="designer__hover--img p_i_e_box">
                            </div>
                            <div class="description" v-if="index != 2" :class="designerBig.indexOf(index) != -1  ? 'fr' : ''">
                                <div class="right__icon"><img :src="icon_right"></div>
                                <div class="info over">
                                    <div class="n">{{item.name}}</div>
                                    <div class="d" v-html="item.sign"></div>
                                </div>
                                <div class="text__bg">{{item.name}}</div>
                            </div>

                            <img :src="icon_down" v-if="index == 2">
                            <div class="read__more transition footFm-but"  v-if="index == 2" @click.stop="preeItem('/strategic')">Read More</div>
                        </div>
                    </div>
                    <div class="blockwite"></div>
                </div>

            </div>
            <!--3.业主心声-->
            <div class="dep__group wrapper__w" style="padding-bottom: 30px">
                <div class="dep__type">
                    <div class="dep__lable wow animate__fadeInUp" >
                        <div>业主心声</div>
                        <div class="eg">Owner Representative</div>
                        <img :src="icon_hyz">
                    </div>
                    <div class="bg" style="height: 350px;"></div>
                </div>
                <div class="ower__swiper--cont wow animate__fadeInUp">
<!--                    <div class="page__button swiper-button-prev" :style="{'background-image': 'url('+icon_sleft+')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"></div>-->
<!--                    <div class="page__button swiper-button-next" :style="{'background-image': 'url('+icon_sright+')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"></div>-->
                    <div class="swiper-container1 ower__swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide relative" v-for="(url, index) in ownerVoice" :key="index" @click="preeItem('/ownervoice', {id: url.id})">
                                <img  :src="url.cover" >
                                <div class="pro__left">
                                    <div class="description">
                                        <div class="info over">
                                            <div class="n">业主说</div>
                                            <div class="d">{{url.name}}</div>
                                        </div>
                                        <div class="text__bg">{{url.name}}</div>
                                        <div class="read__more--vioce">Read More</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="swiper-button-next" style="background-image: none;width: 44px;right: 3%">-->
<!--                        <img :src="banner_sright" style="width: 44px">-->
<!--                    </div>-->
<!--                    <div class="swiper-button-prev" style="background-image: none;width: 44px;left: 3%">-->
<!--                        <img :src="banner_sleft" style="width: 44px">-->
<!--                    </div>-->

                </div>
            </div>
            <!--4.隐上资讯-->
            <div class="wrapper__wpd dep__bg" style="padding-bottom: 50px">
                <div class="time__info">
                    <div class="text wow animate__fadeInUp">
                        <div>隐上资讯</div>
                        <div class="tag">News</div>
                    </div>
                    <div class="read__more transition footFm-but" @click="preeItem('/consultation')">Read More</div>
                </div>
                <div class="time__ul">
                    <div class="time__item wow animate__fadeInUp case_hover_box" @click="preeItem('/consultation/consdetail', {id: itn.id})" v-for="itn in articleList">
                        <div class="time__face hover_box_img"><img :src="itn.cover"> </div>
                        <div class="time__des">
                            <div class="ti">{{itn.time}}</div>
                            <div class="tit textover">{{itn.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
<!--        <div style="height: 3000px"></div>-->
<!--        <div class="animate__animated animate__bounce">我是淡入效果</div>-->
<!--        <div class="hello_world" >-->
<!--                <section class="wow  animate__bounce" data-wow-duration="1s" >-->
<!--            111-->
<!--                </section>-->
<!--                    <section class="wow  animate__bounce" data-wow-duration="2s" >-->
<!--            2222-->
<!--                </section> -->
<!--                    <section class="wow  animate__bounce" data-wow-duration="5s" >-->
<!--            333-->
<!--                </section> -->
<!--                    <section class="wow  animate__bounce" data-wow-duration="6s" >-->
<!--            444-->
<!--                </section> -->
<!--                    <section class="wow  animate__bounce" data-wow-duration="7s" >-->
<!--            5555-->
<!--                </section>       -->
<!--        </div>-->


    </div>
</template>

<script>
    import Vue from 'vue'
    import Footer from '@/layouts/Footer'
    import '@/assets/css/swiper.min.css'
    import scroll from 'vue-seamless-scroll'
    Vue.use(scroll)
    import Swiper, { Navigation, Pagination } from 'swiper';
    Swiper.use([Navigation, Pagination]);
    import { isPhone } from '@/libs/common'
    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue'
    import icon_banner from '@/assets/img/banner.png'
    import icon_pxs from '@/assets/img/pxs.png'
    import icon_hyz from '@/assets/img/hyz.png'
    import icon_fjs from '@/assets/img/fjs.png'
    import icon_user from '@/assets/img/user.png'
    import icon_dl from '@/assets/img/dl.png'
    import icon_right from '@/assets/img/right.png'
    import icon_down from '@/assets/img/down.png'
    import icon_sleft from '@/assets/img/sleft.png'
    import icon_sright from '@/assets/img/sright.png'
    import banner_right from '@/assets/img/banner_right.png'
    import banner_left from '@/assets/img/banner_left.png'
    import banner_sright from '@/assets/img/sindexright.png'
    import banner_sleft from '@/assets/img/sindexleft.png'
    import {Message} from "element-ui";


    export default {
        name: 'Home',
        data (){
            return {
                banner_sright,
                banner_sleft,
                banner_right,
                banner_left,
                icon_banner,
                icon_pxs,
                icon_hyz,
                icon_fjs,
                icon_user,
                icon_dl,
                icon_right,
                icon_down,
                icon_sleft,
                icon_sright,
                timeline: [{
                    name: '初创期',
                    time: '2000-2010',
                    history_id: 1,
                },{
                    name: '发展期',
                    time: '2011-2016',
                    history_id: 2,
                },{
                    name: '成熟期',
                    time: '2017-2018',
                    history_id: 3,
                },{
                    name: '腾飞期',
                    time: '2019-至今',
                    history_id: 4,
                }],
                timeObj: {
                    imgList: [],
                    imgLeft: [],
                    imgRight: [],
                    textList: []
                },
                isTimeObj: false,
                timeLoding: false,
                bannerImgs: [],
                // historyText: [],
                city: '',
                area: '',
                name: '',
                mobile: '',
                isSubmit: false,
                designerList: [],
                designerBig: [0,5,6], // 大于2的都加1
                articleList: [],
                ownerVoice: [],


                urls: [
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                    'https://f10.baidu.com/it/u=1757642172,2249337251&fm=76',
                ]
            }
        },
        computed: {
            classOption () {
                return {
                    singleHeight: 0,
                    hoverStop: false
                }
            },
            classOption1 () {
                return {
                    direction: 2,
                    singleHeight: 0,
                    hoverStop: false
                }
            },
            classOption2 () {
                return {
                    direction: 3,
                    singleHeight: 0,
                    hoverStop: false
                }
            }
        },
        components: {
            Footer,
        },
        // computed: {
        //     swiper() {
        //         return this.$refs.mySwiper.$swiper
        //     }
        // },
        methods: {
            /**
             * @description点击跳转
             * */
            preeItem (path, query, index){
                if (index == 2) return false
                this.$router.push({path, query})
            },
            addKeyFrames (y, classname) {
                var style = document.createElement('style');
                style.type = 'text/css';
                var keyFrames = '\
                @-webkit-keyframes A_DYNAMIC_NAME {\
                    0% {\
                        -webkit-transform: translate3d(0, 0, 0);\
                        transform: translate3d(0, 0, 0);\
                    }\
                    100% {\
                        -webkit-transform: translate3d(0, A_DYNAMIC_VALUE, 0);\
                        transform: translate3d(0, A_DYNAMIC_VALUE, 0);\
                    }\
                }\
                @keyframes A_DYNAMIC_NAME {\
                    0% {\
                        -webkit-transform: translate3d(0, 0, 0);\
                        transform: translate3d(0, 0, 0);\
                    }\
                    100% {\
                        -webkit-transform: translate3d(0, A_DYNAMIC_VALUE, 0);\
                        transform: translate3d(0, A_DYNAMIC_VALUE, 0);\
                    }\
                }';
                let innerHTML = keyFrames.replace(/A_DYNAMIC_VALUE/g, y);
                // style.innerHTML = keyFrames.replace(/A_DYNAMIC_VALUE/g, y);
                innerHTML = innerHTML.replace(/A_DYNAMIC_NAME/g, classname);
                console.log(innerHTML)
                // home__component
                document.querySelector('.home__component').appendChild(innerHTML);
                // document.getElementsByTagName('head')[0].appendChild(innerHTML);
            },
            addKeyFramesText (data, classname){
                let html = '<div class="ss">';
                for(var i = 0; i<data.length; i++){
                    html += '<div class="item" >'+data[i].text+'</div>';
                }
                html += '</div>';
                document.querySelector('.'+classname).innerHTML = html+html; // 复制一份数据
                let height = document.querySelector('.'+classname).offsetHeight; // 一份数据的高度
                this.addKeyFrames( '-'+height+'px', classname); // 设置keyframes
                // document.querySelector(classname).className += ' '+classname
            },
            /**
             * @description获取轮播图
             * */
            getBannner (){
                this.$xhr(this.$api.bannerList, {}).then(res => {
                    this.bannerImgs = res
                    // // banner
                    // new Swiper('.swiper-banner', {
                    //     pagination: {
                    //         el: '.swiper-pagination',
                    //     },
                    //     autoplay: {
                    //         delay: 2500,
                    //         disableOnInteraction: false,
                    //     },
                    //     navigation: {
                    //         nextEl: '.swiper-button-next',
                    //         prevEl: '.swiper-button-prev',
                    //     },
                    // });
                })
            },
            /**
             * @description获取发展史文本和图片
             * */
            getHistoryText (history_id, type, name){
                let url = type == 100 ? this.$api.historyTextList :  this.$api.historyimageList
                this.$xhr(url, {history_id}).then(res => {
                    if (type == 100){
                        this.timeObj.textList = res
                        // setTimeout(()=>{
                        //     this.addKeyFramesText(res, 'timeObj__text--li')
                        // },300)
                    } else {
                        let right = []
                        let left  = []
                        res.map((v, k)=>{
                            if (k % 2 == 0){
                                right.push(v)
                            } else {
                                left.push(v)
                            }
                        })
                        this.timeObj.imgRight = right
                        this.timeObj.imgLeft = left
                        // // 点击发展时期展示
                        // setTimeout(()=>{
                        //     this.timeLoding = false
                        //     new Swiper('.swiper-container', {
                        //         slidesPerView: 4,
                        //         autoplay: {
                        //             delay: 2500,
                        //             disableOnInteraction: false,
                        //         },
                        //         slidesPerColumn: 2,
                        //         spaceBetween: 0
                        //     });
                        // },300)
                    }

                    this.timeObj.time_name = name
                    setTimeout(()=>{
                        this.isTimeObj = true
                    }, 100)

                })
            },
            /**
             * @description点击查看时期详情数据
             * */
            lookTimeLine (index){
                const {history_id, name} = this.timeline[index]
                this.timeLoding = true
                this.getHistoryText(history_id, 100, name)
                this.getHistoryText(history_id, 200, name)
            },
            closeTime (){
                this.timeObj = {
                    imgList: [],
                    imgLeft: [],
                    imgRight: [],
                    textList: []
                }
                this.isTimeObj = false
            },
            /**
             * @description预约提交
             * */
            submitFun (){
                if(!this.city){
                    this.$message.error('请输入城市')
                    return false
                }
                if(!this.area){
                    this.$message.error('请输入面积')
                    return false
                }
                if(!this.name){
                    this.$message.error('请输入称呼')
                    return false
                }
                if(!this.mobile){
                    this.$message.error('请输入联系电话')
                    return false
                }
                if (!isPhone(this.mobile)){
                    this.$message.error('请输入正确的手机号')
                    return false
                }
                this.isSubmit = true
                this.$xhr(this.$api.appNoteHome, {city: this.city, area: this.area, name: this.name, mobile: this.mobile}).then(res => {
                    this.isSubmit = false
                    this.$message({
                        message: '提交成功，稍后会有工作人员联系您，请耐心等待',
                        type: 'success',
                        duration: '3000'
                    });
                })
            },
            /**
             * @description获取合作项目设计师列表
             * */
            getDesiger (){
                this.$xhr(this.$api.designerHomeList, {pagesize: 8, pagenum:1, is_pc: true}).then(res => {
                    res.list.splice(2, 0, {})
                    this.designerList = res.list
                })
            },
            /**
             * @description咨询列表
             * */
            getArticleList (){
                this.$xhr(this.$api.articleList, {pagesize: 4, pagenum:1}).then(res => {
                    this.articleList = res.list
                })
            },
            /**
             * @description业主心声列表
             * */
            getVoiceList (){
                this.$xhr(this.$api.ownerVoice, {pagenum:-1}).then(res => {
                    this.ownerVoice = res.list
                    // 业主心声
                    setTimeout(()=>{
                        new Swiper('.swiper-container1', {
                            slidesPerView: 3,
                            spaceBetween: 50,
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                        });
                    }, 300)

                })
            },


        },
        mounted(){
            this.$wow.init()
            this.$nextTick(() => {
                this.getBannner()
                this.getDesiger()
                this.getArticleList()
                this.getVoiceList()
            })


            // new Swiper('.swiper-banner', {
            //     slidesPerView: 3,
            //     spaceBetween: 50,
            //     // nextButton: '.swiper-button-next',
            //     // prevButton: '.swiper-button-prev',
            //     navigation: {
            //         nextEl: '.swiper-button-next',
            //         prevEl: '.swiper-button-prev',
            //     },
            // });

        },
    }
</script>
<style  lang="scss" scoped>
    .home__component{
        .timeObj__imgs{
            width: 200px;
            height: 200px;
            position: relative;
            float: left;
        }
        .timeObj__text--li{
            height: 480px;
            overflow: hidden;
        }
        .name__text{
            position: absolute;
            left: 0;
            bottom: 0;
            color: #fff;
            text-align: center;
            width: 100%;
            line-height: 40px;
        }
        .banner{
            position: relative;
            .page__banner{
                bottom: 120px;
            }
            .banner__img{
                height: 100%;
                width: 100%;
                display: block;
                object-fit: cover;
            }
            .submit__base{
                position: absolute;
                bottom: 0;
                left: 12%;
                width: 76%;
                height: 72px;
                background: #fff;
                z-index: 222;
                overflow: hidden;
                & > div{
                    width: 19.5%;
                    float: left;
                    &:last-child{
                        width: 22%;
                    }
                }

            }

        }
        .dep__bg{
            background: #F1F1F1;
        }
        .read__more{
            cursor: pointer;
            text-align: center;
            width: 106px;
            height: 36px;
            line-height: 36px;
            border: 2px solid #808080;
            font-size: 16px;
            font-weight: 400;
            color: #808080;
            position: absolute;
            right: 0;
            bottom: 0;
        }
        .read__more--vioce{
            text-align: center;
            line-height: 28px;
            width: 116px;
            height: 28px;
            font-size: 16px;
            font-weight: normal;
            font-family: Arial;
            color: #FEFEFE;
            background: #E95313;
            position: absolute;
            right: 0px;
            bottom: 40px;
        }
        .dep__group {
            .dep__lable {
                width: 300px;
                position: absolute;
                left: 50%;
                margin-left: -150px;
                top: 40%;
                font-size: 36px;
                font-weight: 400;
                color: #000000;
                text-align: center;

                .eg {
                    font-size: 18px;
                    font-family: Arial;
                    font-weight: 400;
                    color: #F55E1B;
                }

                & > div {
                    position: relative;
                    z-index: 2;
                }

                img {
                    display: block;
                    position: absolute;
                    z-index: 1;
                    width: 118px;
                    height: 130px;
                    top: -35px;
                    left: 50%;
                    margin-left: -59px;
                }
                .bg{
                    img{
                        /*height: 416px;*/
                    }
                }
            }
            .dep__type{
                position: relative;
            }
            .bg{
                img{
                    width: 100%;
                }
            }
            .timeObj__box{
                position: absolute;
                left: 0;
                top: 0;
                z-index: 222;
                width: 100%;
            }
            .dep__show{
                height: 540px;
                position: relative;
                & > div{
                    margin: 0 6%;
                    position: relative;
                    top: 40px;
                }
                .dep__time{
                    position: relative;
                    font-size: 22px;
                    font-weight: 400;
                    color: #000000;
                    padding-left: 10px;
                    margin-bottom: 30px;
                    &::before{
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 1px;
                        width: 4px;
                        height: 21px;
                        background: #EA5413;
                    }
                }
                .dep__lay{
                    width: 80%;
                    img{
                        display: block;
                        width: 100%;
                        height: 200px;
                        object-fit: cover;
                    }

                }
                .dep__des{
                    width: 20%;
                    height: 400px;
                    background: rgba(255,255,255,1);
                    font-size: 16px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 30px;
                    position: relative;
                    & > div{
                        margin: 10%;
                    }
                    span{
                        position: relative;
                        z-index: 2;
                    }
                    img{
                        position: absolute;
                        width: 70%;
                        left: 50%;
                        margin-left: -35%;
                        margin-top: -35%;
                        top:50%;
                        z-index: 1;
                    }
                }
            }
        }
        .dep__time--line{
            height: 540px;
            .line__item{
                cursor: pointer;
                position: relative;
                color: #fff;
                width: 25%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                transition: all 1s;
                -moz-transition: all 1s; /* Firefox 4 */
                -webkit-transition: all 1s; /* Safari 和 Chrome */
                -o-transition: all 1s; /* Opera */
                text-align: center;
                opacity: .8;
                color: #fff;
                .name{
                    font-size: 22px;
                    font-weight: 400;
                }
                .time{
                    font-size: 18px;
                    font-weight: 300;
                }
                .line__tag{
                    display: inline-block;
                    width: 20px;
                    height: 4px;
                    background: #F15315;
                }
                .bot{
                    width: 100%;
                    position: absolute;
                    left: 50%;
                    margin-left: -50%;
                    bottom: 50px;
                }
            }
            .line__item::after{
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 1px;
                height: 100%;
                background: rgba(255, 255, 255, 0.5);
            }
            .line__item:hover{
                background-color: rgba(0, 0, 0, .1);
            }
        }
        .right__icon{
            width: 74px;
            height: 40px;
            background: #EA5413;
            position: absolute;
            right: 0;
            top: 0;
            img{
                float: right;
                width: 27px;
                height: 27px;
                display: block;
                position: relative;
                top: 6px;
            }
        }
        .text__bg{
            position: absolute;
            left: 0;
            bottom: 0;
            font-size: 76px;
            font-weight: 500;
            color: #F55E1B;
            opacity: 0.1;
            writing-mode: vertical-rl;
        }
        .pro__left{
            /*width: 600px;*/
            width: 47%;
            height: 400px;
            .head{
                width: 65%;
                height: 100%;
                img{
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                }
            }
            .description{
                width: 35%;
                height: 100%;
                position: relative;
                background: #fff;
                .info{
                    margin-top: 60px;
                    padding-left: 15px;
                    & > div{
                        float: right;
                        margin-left: 10px;
                    }
                    .n{
                        /*letter-spacing: 20px;*/
                        writing-mode: vertical-rl;
                        width: 28px;
                        font-size: 28px;
                        font-weight: 500;
                        color: #010101;
                        position: relative;
                        padding-left: 15px;
                        /*padding-bottom: 20px;*/
                        margin-right: 30px;
                        min-height: 110px;
                        &::before{
                            position: absolute;
                            left: 0;
                            top: 0;
                            content: '';
                            width: 2px;
                            height: 100%;
                            background: #F55E1B;
                        }
                    }
                    .d{
                        height: 275px;
                        font-size: 14px;
                        line-height: 26px;
                        font-weight: 400;
                        color: #000000;
                        writing-mode: vertical-rl;
                        /*max-width: 40%;*/
                        width: 50px;
                        overflow: hidden;
                        /*overflow-x: scroll;*/
                        margin-left: 0;
                    }
                }

            }
        }
        .pro__top{
            width: 22%;
            position: relative;
            .head{
                height: 260px;
                img{
                    width: 100%;
                    height: 260px;
                    display: block;
                    object-fit: cover;
                }
            }
            .description{
                width: 100%;
                height: 140px;
                position: relative;
                background: #fff;
            }
            .n{
                display: inline-block;
                font-size: 28px;
                font-weight: bold;
                color: #010101;
                position: relative;
                padding-right: 15px;
                padding-bottom: 5px;
                margin-top: 3px;
                &::before{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #F55E1B;
                }
            }
            .d{
                font-size: 14px;
                line-height: 22px;
                font-weight: 400;
                color: #000000;
                margin-top: 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
            }
            .info{
                padding-left: 15px;
            }
            .text__bg{
                left: unset;
                right: 0;
                font-size: 60px;
                writing-mode: unset;
            }
        }
        .pro__down{
            width: 22%;
            text-align: right;
            height: 400px;
            position: relative;
            img{
                width: 28px;
                height: 56px;
                position: relative;
                top: 130px;
            }
        }
        .pro__user > div{
            margin-right: 3%;
            margin-bottom: 3%;
            cursor: pointer;
            &:hover{
                .designer__picture{
                    opacity:0;
                    -webkit-transform: matrix(1.05,0,0,1.05,0,0);
                    -moz-transform: matrix(1.05,0,0,1.05,0,0);
                    -ms-transform: matrix(1.05,0,0,1.05,0,0);
                    -o-transform: matrix(1.05,0,0,1.05,0,0);
                    transform: matrix(1.05,0,0,1.05,0,0);
                }
                .designer__hover--img{
                    opacity:1;
                    -webkit-transform: matrix(1,0,0,1,0,0);
                    -moz-transform: matrix(1,0,0,1,0,0);
                    -ms-transform: matrix(1,0,0,1,0,0);
                    -o-transform: matrix(1,0,0,1,0,0);
                    transform: matrix(1,0,0,1,0,0);
                }
            }
        }
        .pro__user > div:nth-child(3n){
            margin-right: 0;
        }
        .ower__swiper--cont{
            position: relative;
            .page__button{
                width: 36px;
                height: 36px;
                top: -50px!important;
                left: unset!important;
                right: 0!important;
            }
            .swiper-button-prev{
                margin-right: 50px;
            }
        }
        .ower__swiper{
            position: relative;
            width: 100%;
            overflow: hidden;
            /*overflow-y: scroll;*/
            .swiper-slide{
                max-width: 33%;
                cursor: pointer;
            }
            .pro__left{
                position: absolute;
                right: 20px;
                bottom: 20px;
                width: 180px;
                height: 294px;
                .description{
                    width: 100%;
                }
                .info{
                    margin-top: 0;
                    padding-top: 20px;
                }
                .n{
                    margin-right: 20px!important;
                    padding-bottom: 0!important;
                }
                .d{
                    letter-spacing: 6px;
                    height: auto!important;
                    width: auto!important;
                    float: right;
                    font-size: 16px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 36px;
                }
                .text__bg{
                    font-size: 48px;
                    left: 10px;
                    bottom: 10px;
                }
            }
            img{
                height: 540px;
                width: 100%;
                display: block;
                object-fit: cover;
            }

        }
        .time__info{
            position: relative;
            height: 110px;
            .text{
                top: 33px;
                position: relative;
                font-size: 36px;
                font-weight: 400;
                color: #000000;
                padding-left: 20px;
                &::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 4px;
                    width: 6px;
                    height: 53px;
                    background: #F55E1B;
                }
                .tag{
                    font-size: 18px;
                    font-family: Arial;
                    font-weight: normal;
                    color: #EA5413;
                }
            }
            .read__more{
                bottom: 35px;
            }
        }
        .time__ul {
            overflow: hidden;
            .time__item {
                cursor: pointer;
                width: 22.75%;
                float: left;
                margin-right: 3%;
                img{
                    width: 100%;
                    display: block;
                    height: 184px;
                }
                .time__des{
                    background: #fff;
                    padding-top: 7px;
                    .ti{
                        font-size: 12px;
                        font-weight: 400;
                        color: #808080;
                        position: relative;
                        display: inline;
                        padding-left: 15px;
                        padding-bottom: 2px;
                        &::before{
                            content: '';
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            height: 2px;
                            width: 100%;
                            background: #F55E1B;
                        }
                    }
                    .tit{
                        padding: 10px 15px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #000000;
                        padding-bottom: 20px;
                    }
                }
            }
            .time__item:last-child{
                margin-right: 0;
            }
        }
        .p_i_e_box{
            transition: all 0.3s ease-in-out;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            &.designer__picture{
                opacity:1;
                -webkit-transform: matrix(1,0,0,1,0,0);
                -moz-transform: matrix(1,0,0,1,0,0);
                -ms-transform: matrix(1,0,0,1,0,0);
                -o-transform: matrix(1,0,0,1,0,0);
                transform: matrix(1,0,0,1,0,0);
            }
            &.designer__hover--img{
                opacity: 0;
                -webkit-transform: matrix(1.1,0,0,1.1,0,0);
                -moz-transform: matrix(1.1,0,0,1.1,0,0);
                -ms-transform: matrix(1.1,0,0,1.1,0,0);
                -o-transform: matrix(1.1,0,0,1.1,0,0);
                transform: matrix(1.1,0,0,1.1,0,0);
            }
        }
    }
    .pro__left{
        .text__bg{
            min-height: 240px;
            text-align: end;
        }
    }

</style>
